<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="workorderunbinding"
      ref="list"
      unit="工单解绑单"
      :page="page"
      :show-query="true"
      :get-data-func="api.vList"
      v-if="trendShow"
      urlHash="business/stock/workorderunbinding"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/production/unBindMaterial").default,
      trendShow: true,
    };
  },

  methods: {},
};
</script>
